<template>
    <v-card>
        <v-card-title class="headline primary darken-1 white--text">
            <span>Confirm to Activate User</span>
        </v-card-title>

        <v-card-text class="mt-2">
            <div class="pt-4 d-block">
                Click the confirm button below to affirm that you want to <strong>activate</strong> this user's account.
            </div>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn 
                class="mr-3" 
                outlined 
                color="primary darken-1"
                @click="closeDialog()">
                Cancel
            </v-btn>
            <v-btn 
                class="white--text" 
                color="primary darken-1"
                @click="activateUser()">
                Confirm
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>  
    import axios from "axios";
    import Cookie from 'js-cookie';
    import appUrls from '../../helpers/environment';

    export default {
        name: 'ActivateUserConfirmation',

        props: {
            selectedUser: Object,
            updateSwitchState: Function,
            closeActivateDialog: Function
        },

        data () {
            return {
            }
        },

        methods: {
            activateUser: async function () {
                try {
                    if ( this.selectedUser.user_id ) {
                        const activate_user = await axios.put(`${appUrls.api}/api/admin/active`, {
                            headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                            update: {
                                user_id: this.selectedUser.user_id,
                                is_active: true,
                                org_index: 0,
                            }
                        })
                    
                        if ( activate_user.data.outcome ) {
                            this.selectedUser.is_active = activate_user.data.user.is_active
                            if ( activate_user.data.user.is_active ) {
                                this.resendWelcomeEmail()
                            }
                        }
                    }
                } catch ( error ) {
                    console.log(error);
                }
            },

            resendWelcomeEmail: async function () {
                try {
                    const resend_email = await axios.put(`${appUrls.api}/api/admin/resend_welcome/${this.selectedUser.user_id}/welcome_email_reset`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                    })
                
                    if ( resend_email.data.outcome ) {
                        this.$emit( 'selectedUser', this.selectedUser)
                        this.closeDialog()
                    }
                } catch ( error ) {
                    console.log(error);
                }
            },

            closeDialog: function () {
                this.$emit( 'updateSwitchState', false)
                this.$emit( 'closeActivateDialog', false )
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/dialogs/ActivateUserConfirmation.vue